// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apid: 'http://localhost:5300/api',
  api: 'https://api-miviaje.denariotest.com.co/api/',
  apiWaderlust: 'https://wanderlus-adminpanel-prod-aad2g6dggfgsesey.eastus2-01.azurewebsites.net/api',
  amadeusApi: 'https://amadeus-api-php-dev-cgabcqbegshhcfby.eastus2-01.azurewebsites.net',
  token: 'oesZZmHNycbhBXjBoVQi9YXi5M3hMdXm6gEHUWHE154e8f72'
};
